/*
 * Jira Ticket:
 * Created Date: Fri, 17th Jan 2020, 16:14:54 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

export default ({ type, resource, params }) => {
  // format, edit params here
  if (resource === 'Site' && type === 'UPDATE') {
    if (params.data && params.data.projectId) {
      params.data.project.id = params.data.projectId;
      params.data['project.id'] = params.data.projectId;
    }
    return params;
  }
  if (resource === 'Region' && type === 'UPDATE') {
    if (params.data && params.data.countriesIds) {
      params.data.countries = params.data.countriesIds;
    }
    if (params.data && params.data.localesIds) {
      params.data.locales = params.data.localesIds;
    }
    return params;
  }
};
